import React, { Component } from 'react';
import { NO_IMG_URL } from 'Utils/constants';
import { Link } from 'react-router-dom';
import styles from './device.module.less';

export default class Device extends Component {
  render() {
    let a = this.props.device;
    let imgSrc = a.asset == null ? NO_IMG_URL : a.asset.path;
    return (
      <div className={styles.deviceBox}>
        <Link to={a.url} className={styles.deviceLink}>
          <div className={styles.content}>
            <img src={imgSrc} alt={a.title} className={styles.deviceImg} />
            <p className={styles.title}>{a.title}</p>
          </div>
        </Link>
      </div>
    );
  }
}
